import React from "react";

const Star = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 13.0901L3.24717 16L4.42018 10.1566L0 6.11166L5.97823 5.40999L8.5 0L11.0218 5.40999L17 6.11166L12.5798 10.1566L13.7528 16L8.5 13.0901ZM8.5 11.4008L11.663 13.1528L10.9562 9.63479L13.6173 7.19882L10.0178 6.77649L8.5 3.51944L6.98217 6.77723L3.38272 7.19882L6.04377 9.63479L5.33698 13.1528L8.5 11.4008Z"
      fill="#FFD705"
    />
  </svg>
);

export default Star;
